// extracted by mini-css-extract-plugin
export var linksText = "footer-modules--linksText--3I-2J";
export var columnText = "footer-modules--columnText--5JiTM";
export var w11by24 = "footer-modules--w11by24--1sNOZ";
export var partnerImageContainer = "footer-modules--partnerImageContainer--2uSlF";
export var partnerImage = "footer-modules--partnerImage--1R-w-";
export var copyText = "footer-modules--copyText--RF3um";
export var partnersBlockTitle = "footer-modules--partnersBlockTitle--1Wiiy";